import { useEffect, useState } from "react";
export default function useMediaQuery(query) {
  const [matches, setMatches] = useState(() => typeof window.matchMedia !== "function" || window.matchMedia(query).matches);
  useEffect(() => {
    if (typeof window.matchMedia !== "function") return;
    const media = window.matchMedia(query);
    const update = () => setMatches(media.matches);
    update(); media.addEventListener("change", update);
    return () => media.removeEventListener("change", update);
  }, [query]);
  return matches;
}
